import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Typography as T } from "@mui/material";

import { useStoreState } from "store/store";
import { palette } from "theme/palette";

import { CarCard } from "./components/CarCard";

const CarCardsSection = () => {
  // state
  const cardsData = useStoreState((s) => s.vehicles);
  const selectedCar = useStoreState((s) => s.selectedCar);
  const { control, setValue } = useFormContext();

  useEffect(() => {
    setValue("selectedCar", selectedCar);
  }, [selectedCar]);

  return (
    <Controller
      control={control}
      name="selectedCar"
      defaultValue={null}
      rules={{ required: true }}
      render={({ field: { onChange, value }, fieldState: { invalid } }) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            gap: "16px",
            "&::-webkit-scrollbar": {
              width: 7,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "accent",
              borderRadius: 5,
              minHeight: 30,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: palette.grey,
            },
          }}
        >
          {cardsData.map((data, i: number) => {
            return (
              <CarCard
                key={i}
                cardData={{ ...data }}
                setSelectedCar={onChange}
                activeCar={value}
              />
            );
          })}
          {invalid && (
            <T variant="h3" color={palette.error}>
              Please, select a car shown above
            </T>
          )}
        </Box>
      )}
    />
  );
};

export default CarCardsSection;
